/* Custom */
import "@/ts/utils/disable-hash-jump";

/* Lazyloading */
import "lazysizes";
import "lazysizes/plugins/unveilhooks/ls.unveilhooks";

/* Animation */
import AOS from "aos";
import "aos/dist/aos.css";

AOS.init({
    offset: 120, // offset (in px) from the original trigger point
    delay: 0, // values from 0 to 3000, with step 50ms
    duration: 400, // values from 0 to 3000, with step 50ms
    easing: "ease", // default easing for AOS animations
    once: true, // whether animation should happen only once - while scrolling down
    mirror: false, // whether elements should animate out while scrolling past them
    anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation
});

/* Vue */
import { createApp } from "vue";
import { createPinia } from "pinia";
import SvgVue from "svg-vue3";
import { VueReCaptcha } from "vue-recaptcha-v3";

import App from "./App.vue";
import StickyHeader from "./components/elements/sticky-header.vue";
import LanguageSwitch from "./components/elements/language-switch.vue";
import Slideout from "./components/elements/slideout.vue";
import SlideoutNavigation from "./components/elements/slideout-navigation.vue";
import IntroVideoButton from "./components/elements/intro-video-button.vue";
import Countup from "./components/elements/countup.vue";
import TextLabel from "./components/elements/text-label.vue";
import ContactForm from "./components/contact/contact-form.vue";
import UniversalVideo from "./components/elements/universal-video.vue";
import Carousel from "./components/elements/carousel.vue";

const app = createApp(App);

app.use(SvgVue);
app.use(createPinia());
app.use(VueReCaptcha, { siteKey: RECAPTCHA_SITE_KEY, loaderOptions: { autoHideBadge: true } });

app.component("StickyHeader", StickyHeader);
app.component("SlideoutNavigation", SlideoutNavigation);
app.component("IntroVideoButton", IntroVideoButton);
app.component("ContactForm", ContactForm);
app.component("Countup", Countup);
app.component("TextLabel", TextLabel);
app.component("LanguageSwitch", LanguageSwitch);
app.component("UniversalVideo", UniversalVideo);
app.component("Carousel", Carousel);

app.mount("#app");
